export default function TestimonialsSection() {
  return (
    <div className="py-24 bg-white px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-gray-900 mb-4">
          El Paso Homeowners Trust Us
        </h2>
        <p className="text-center text-gray-600 text-lg mb-16 max-w-3xl mx-auto">
          Real stories from real people we've helped sell their distressed properties
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="flex items-center gap-1 mb-4">
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed italic">
              "My house had major foundation problems and I thought I'd never be able to sell it. TRex RE LLC gave me a fair offer and closed in 10 days. They handled everything and I didn't have to fix a single thing. Absolute lifesavers!"
            </p>
            <div className="border-t border-gray-200 pt-4">
              <h4 className="font-bold text-gray-900">Maria Gonzalez</h4>
              <p className="text-teal-600 text-sm font-medium">East El Paso Homeowner</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="flex items-center gap-1 mb-4">
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed italic">
              "After my father passed away, I inherited his home but lived out of state. TRex RE LLC made the process so easy. They bought it as-is, handled all the paperwork, and I never had to fly back to El Paso. Highly recommend!"
            </p>
            <div className="border-t border-gray-200 pt-4">
              <h4 className="font-bold text-gray-900">Robert Chen</h4>
              <p className="text-teal-600 text-sm font-medium">Inherited Property Seller</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="flex items-center gap-1 mb-4">
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
              <i className="ri-star-fill text-yellow-400 text-xl"></i>
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed italic">
              "I was facing foreclosure and didn't know what to do. TRex RE LLC stepped in, gave me a fair offer, and closed before the foreclosure date. They saved my credit and treated me with respect during a difficult time."
            </p>
            <div className="border-t border-gray-200 pt-4">
              <h4 className="font-bold text-gray-900">Jennifer Martinez</h4>
              <p className="text-teal-600 text-sm font-medium">Northeast El Paso</p>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-center gap-12 opacity-70">
          <div className="flex items-center gap-2">
            <i className="ri-google-fill text-4xl text-gray-700"></i>
            <div>
              <div className="flex items-center gap-1">
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
              </div>
              <p className="text-sm text-gray-600 font-medium">4.9/5 Rating</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-facebook-circle-fill text-4xl text-gray-700"></i>
            <div>
              <div className="flex items-center gap-1">
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
              </div>
              <p className="text-sm text-gray-600 font-medium">5.0/5 Rating</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
